<div *ngIf="!isLoggedinUser">
  <div class="row">
    <div class="col-3 pd-10">
      <div class="vs-checkbox">
        <input
          id="shipToAddress"
          type="checkbox"
          value="true"
          [(ngModel)]="isSoldToAddress"
          (change)="toggleSoldToAddress()"
        />
        <label for="shipToAddress"> {{ "quoteCheckout.sameAsSoldAddress" | cxTranslate }} </label>
      </div>
    </div>
  </div>
  <div [formGroup]="shipToAddress">
    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div class="vs-text-field">
          <label>{{ "quoteCheckout.companyName" | cxTranslate }} </label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.companyName" | cxTranslate }} '
            formControlName="companyName"
            [attr.maxlength]="maxVal"

          />
        </div>
      </div>
    </div>

    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div class="vs-text-field">
          <label><span class="require">* </span>{{ "quoteCheckout.endUserAddressL1" | cxTranslate }}</label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserAddressL1" | cxTranslate }}'
            [ngClass]="
              (line1.invalid &&
                (line1.dirty || line1.touched) &&
                !line1.valid) ||
              (!shipToAddress.valid && isSubmitted && !line1.valid)
                ? 'error'
                : ''
            "
            formControlName="line1"
            maxlength="35"
          />
          <label
            class="tag-section-custom-label-width custom-label"
            *ngIf="!shipToAddress.valid && isSubmitted && !line1.valid"
          >
          {{ "quoteCheckout.endUserAddressL11" | cxTranslate }}
          </label>
        </div>
      </div>

      <div class="col-3">
        <div class="vs-text-field">
          <label>{{ "quoteCheckout.endUserAddressL2" | cxTranslate }}</label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserAddressL2" | cxTranslate }}'
            formControlName="line2"
            maxlength="35"
          />
        </div>
      </div>
    </div>

    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div>
          <label
            ><span class="require red-color">* </span
            ><span class="label-custom">{{ "quoteCheckout.endUserCountry" | cxTranslate }}</span></label
          >
          <ng-select
            #countryFocus
            [searchable]="true"
            [clearable]="false"
            placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
            formControlName="country"
            [ngClass]="
              (shipToAddress.invalid && isSubmitted && country.invalid) ||
              (shipToAddress.invalid &&
                isSubmitted &&
                country.value == 'Select')
                ? 'error-select'
                : ''
            "
            (change)="saveCountryData()"
          >
            <ng-option
              *ngFor="let country of countryNames"
              [value]="country.isocode"
              >{{ country.name }}</ng-option
            >
          </ng-select>
          <label
            class="error"
            *ngIf="
              (!shipToAddress.valid && isSubmitted && country.invalid) ||
              (shipToAddress.invalid &&
                isSubmitted &&
                country.value == 'Select')
            "
          >
          {{ "quoteCheckout.endUserCountry2" | cxTranslate }} 
          </label>
        </div>
      </div>

      <div class="col-3">
        <div>
          <label
            ><span class="require red-color" *ngIf="countryRegionNames?.length>0">* </span
            ><span class="label-custom">{{ "quoteCheckout.endUserState" | cxTranslate }}</span></label
          >
          <ng-select
            #stateFocus
            [searchable]="true"
            [clearable]="false"
            placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
            formControlName="state"
            [ngClass]="
              isSubmitted &&
              (state.invalid || !state.value || state.value == 'Select')
                ? 'error-select'
                : ''
            "
            (change)="selectState()"
          >
            <ng-option
              *ngFor="let region of countryRegionNames"
              [value]="region.isocode"
              >{{ region.name }}</ng-option
            >
          </ng-select>

          <label
            class="error"
            *ngIf="
              isSubmitted &&
              (state.invalid || !state.value || state.value == 'Select')
            "
          >
          {{ "quoteCheckout.endUserState2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>

    <div class="row mt-22">
      <div class="col-3 ml-12">
        <div class="vs-text-field">
          <label><span class="require">* </span>{{ "quoteCheckout.endUserCity" | cxTranslate }}</label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserCity" | cxTranslate }}'
            formControlName="city"
            maxlength="35"
            [ngClass]="
              (city.invalid && (city.dirty || city.touched) && !city.valid) ||
              (!shipToAddress.valid && isSubmitted && !city.valid)
                ? 'error'
                : ''
            "
          />
          <label
            class="tag-section-custom-label-width custom-label"
            *ngIf="!shipToAddress.valid && isSubmitted && !city.valid"
          >
          {{ "quoteCheckout.endUserCity2" | cxTranslate }}
          </label>
        </div>
      </div>

      <div class="col-3">
        <div class="vs-text-field">
          <label><span class="require" *ngIf="country.value != 'CN'">* </span>{{ "quoteCheckout.endUserZip" | cxTranslate }}</label>
          <input
            type="text"
            placeholder='{{ "quoteCheckout.endUserZip" | cxTranslate }}'
            [ngClass]="
              (postalCode.invalid &&
                (postalCode.dirty || postalCode.touched) &&
                !postalCode.valid) ||
              (!shipToAddress.valid && isSubmitted && !postalCode.valid)
                ? 'error'
                : ''
            "
            formControlName="postalCode"
            maxlength="10"
          />
          <label
            class="tag-section-custom-label-width custom-label"
            *ngIf="!shipToAddress.valid && isSubmitted && !postalCode.valid"
          >
          {{ "quoteCheckout.endUserZip2" | cxTranslate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isLoggedinUser">
  <div class="shipToAddingContainer">
    <div class="shiping-details">
      <div class="row">
        <div class="col-md-4 col-lg-4 col-sm-4">
          <div class="section-container">
            {{ "quoteCheckout.guestCheckoutShip2" | cxTranslate }}
            <span
              *ngIf="selectedAddress?.country || selectedAddress?.firstName"
              class="selected"
            >
              <span class="sel">{{ "quoteCheckout.selected" | cxTranslate }}</span></span
            >
          </div>

          <address
            [ngClass]="this.quoteCartType == QuoteStatus.EDIT ? 'disabled' : ''"
          >
            <div>
              {{ selectedAddress?.firstName }} {{ selectedAddress?.lastName }}
            </div>
            <div>
              {{ selectedAddress?.companyName
              }}{{ selectedAddress?.companyName ? "," : "" }}
            </div>
            <div>
              {{ selectedAddress?.line1
              }}{{ selectedAddress?.line1 ? "," : " " }}
              {{ selectedAddress?.line2
              }}{{ selectedAddress?.line2 ? "," : " " }}
            </div>
            <div>
              {{ selectedAddress?.town }}{{ selectedAddress?.town ? "," : " " }}
            </div>
            <div>
              {{ selectedAddress?.region?.name
              }}{{ selectedAddress?.region?.name ? "," : " " }}
            </div>
            <div>
              {{ selectedAddress?.country?.name
              }}{{ selectedAddress?.country?.name ? "," : " " }}
            </div>
            <div>{{ selectedAddress?.postalCode }}</div>
          </address>
          <div
            class="ter-btn-holder"
            *ngIf="!isSelectAddress && this.quoteCartType != QuoteStatus.EDIT"
          >
            <button
              class="vs-tertiary-btn shipAddressBtn"
              (click)="selectAddress()"
              [disabled]="this.quoteCartType == QuoteStatus.EDIT"
            >
              <span
                *ngIf="selectedAddress?.country || selectedAddress?.firstName"
              >
              {{ "quoteCheckout.selectAnotherAddress" | cxTranslate }}
              </span>
              <span
                *ngIf="selectedAddress == null || selectAddress == undefined"
              >
              {{ "quoteCheckout.selectAddress2" | cxTranslate }} 
              </span>
            </button>
          </div>
        </div>
        <div class="col-md-8 col-lg-8 col-sm-8 fl_right">
          <vs-address
            *ngIf="isSelectAddress"
            [componentAddress]="componentAddress"
            [cartName]="cartName"
            (reciveShipToAddress)="selectedAdd($event)"
            (closeShipAdd)="closeForm($event)"
          ></vs-address>
        </div>
      </div>
    </div>
  </div>
</div>
